import { toIcons } from "../../consts/Paths";
import useIsMobile from "../../hooks/useIsMobile";
import { getSuccessRate } from "../../utils/getMethods";

const ModelProposal = (props: any) => {
  const { isMobile } = useIsMobile();

  const successRate = getSuccessRate(
    props.model?.proposal.proposed_times,
    props.model?.proposal.approved_times
  );


  return (
    <div
      className="proposal"
      style={{
        flexDirection: isMobile ? "column" : "row",
        width: isMobile ? "345px" : "",
        gap: isMobile ? "22px" : "",
        margin: isMobile ? "22px " : "",
        padding: isMobile ? "29px 0" : "",
      }}
    >
      <div
        className="rate-box"
        style={{
          alignItems: isMobile ? "flex-end" : "",
        }}
      >
        <p
          className="rate-field"
          style={{
            width: isMobile ? "0" : "",
            fontSize: isMobile ? "16px" : "",
          }}
        >
          Proposal
        </p>
        <div
          className="rate-value-box"
          style={{
            gap: isMobile ? "0" : "",
          }}
        >
          <span
            className="rate-value"
            style={{
              marginLeft: isMobile ? "20px" : "",
            }}
          >
            <p
              className="rate-value-primary"
              style={{ marginLeft: isMobile ? "50px" : "" }}
            >
              {props.model?.proposal.approved_times}
            </p>
            <p
              className="rate-value-secondary"
              style={{ marginRight: isMobile ? "19px" : "" }}
            >
              /{props.model?.proposal.proposed_times}
            </p>
          </span>
          <span className="rate-trend-box">
            <div
              className="rate-trend-iconBG"
              style={{
                width: isMobile ? "16px" : "",
                padding: isMobile ? "0" : "",
              }}
            >
              <img
                className="rate-trend-icon white"
                style={{
                  width: isMobile ? "16px" : "",
                  padding: isMobile ? "0" : "",
                }}
                src={`${toIcons}/small-up.svg`}
              />
            </div>
            <p className="rate-trend-percentage">{/* SUCCESS RATE ???*/}%</p>
          </span>
        </div>
      </div>
      <div
        className="rate-box"
        style={{ alignItems: isMobile ? "flex-end" : "" }}
      >
        <p
          className="rate-field"
          style={{
            width: isMobile ? "fit-content" : "",
            fontSize: isMobile ? "16px" : "",
            margin: isMobile ? "0 0 0 0" : "",
          }}
        >
          Success Rate
        </p>
        <div
          className="rate-value-box"
          style={{
            gap: isMobile ? "0" : "",
          }}
        >
          <span
            className="rate-value"
            style={{
              marginLeft: isMobile ? "20px" : "",
            }}
          >
            <p
              className="rate-value-primary"
              style={{ marginLeft: isMobile ? "0" : "" }}
            >
              {successRate.toString().substring(0, 2)}
            </p>
            <p
              className="rate-value-secondary"
              style={{ marginRight: isMobile ? "19px" : "" }}
            >
              ,
              {successRate === 0
                ? "00"
                : successRate.toString().substring(3, 5)}
              %
            </p>
          </span>
          <span className="rate-trend-box">
            <div
              className="rate-trend-iconBG"
              style={{
                width: isMobile ? "16px" : "",
                padding: isMobile ? "0" : "",
              }}
            >
              <img
                className="rate-trend-icon white"
                style={{
                  width: isMobile ? "16px" : "",
                  padding: isMobile ? "0" : "",
                }}
                src={`${toIcons}/small-up.svg`}
              />
            </div>
            <p className="rate-trend-percentage">{/* SUCCESS RATE ???*/}%</p>
          </span>
        </div>
      </div>
    </div>
  );
};
export default ModelProposal;
